var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin OH
 * @contact hjoh@detech.co.kr
 * @date 2023-10-23
 * @brief  로그아웃 컴포넌트
 *
 *
 ********************************************************************/
import React from "react";
import { useNavigate } from "react-router-dom";
//
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
import { urlState } from "../../recoil/menuState";
//
import { demo, userInfoLoginState, userInfoState } from "../../recoil/userState";
//
import * as HttpUtil from "../../utils/api/HttpUtil";
import * as CUTIL from "../../utils/commUtils";
import * as CONST from "../../utils/Const";
import { useTrans } from "../../utils/langs/useTrans";
const Logout = (props) => {
    const navigate = useNavigate();
    const t = useTrans();
    const userInfo = useRecoilValue(userInfoLoginState);
    const demos = useRecoilValue(demo);
    const resetRecoilUserInfo = useResetRecoilState(userInfoState);
    const setRecoilUrl = useSetRecoilState(urlState);
    function onClickLogout(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HttpUtil.PromiseHttp({
                httpMethod: "POST",
                appPath: `/auth/logout?userId=${userInfo.userId}`,
                appQuery: {
                    userId: userInfo.userId,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == 200) {
                    sessionStorage.removeItem(CONST.STR_TOKEN);
                    sessionStorage.removeItem(CONST.STR_TOKEN_EXPIRETIME);
                    localStorage.removeItem(CONST.STR_KEEP_LOGIN_YN);
                    localStorage.removeItem(CONST.STR_USERID);
                    localStorage.removeItem(CONST.STR_USERROLE);
                    localStorage.removeItem(CONST.STR_REFRESHTOKEN);
                    localStorage.removeItem(CONST.STR_REFRESHTOKEN_EXPIRETIME);
                    localStorage.removeItem("demo");
                    resetRecoilUserInfo();
                    if (demos) {
                        localStorage.removeItem("demo");
                        setRecoilUrl(CONST.URL_MAIN);
                        navigate(CONST.URL_MAIN);
                    }
                    else {
                        setRecoilUrl(props.path);
                        navigate(props.path);
                    }
                    localStorage.setItem("loginintro", CONST.URL_MAIN);
                    location.reload();
                }
            }
        });
    }
    return (_jsx(React.Fragment, { children: _jsx("div", Object.assign({ id: props.path == CONST.URL_MAIN ? "pop-logout_len" : "pop-logout", className: "popup-layer js-layer layer-out hidden popup-basic popup-logout" }, { children: _jsxs("div", Object.assign({ className: "page-detail" }, { children: [_jsxs("div", Object.assign({ className: "popup__head" }, { children: [_jsx("h1", { children: "Logout" }), _jsx("button", Object.assign({ className: "btn btn-close", onClick: (e) => CUTIL.jsclose_Popup("pop-logout") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] })), demos ? (_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: t("라벨.체험을종료하시겠습니까") }) }))) : (_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: t("라벨.로그아웃하시겠습니까") }) }))), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-logout") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", className: "js-close", onClick: (e) => onClickLogout(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] })) })) }));
};
export default Logout;
